import { computed, Service, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { timer } from 'rxjs';
import { debounce, distinctUntilChanged } from 'rxjs/operators';

export const DEFAULT_AFTER = 800;
export const DEFAULT_MINIMUM = 500;

@Service()
export class SpinnerService {
  readonly #count = signal(0);

  readonly active$ = toObservable(computed(() => this.#count() > 0))
    .pipe(
      debounce((isActive) => timer(isActive ? DEFAULT_MINIMUM : DEFAULT_AFTER)),
      distinctUntilChanged(),
    );

  add(): void {
    this.#count.update((count) => count + 1);
  }

  remove(): void {
    this.#count.update((count) => Math.max(0, count - 1));
  }
}
